import { createAppApiClient } from '@e-learning/core';
import { getApiBaseUrl, i18n } from '@e-learning/shared';
import { AUTH_DATA_KEY } from '../auth';

//DEV
// const B2B_API_BASE_URL = 'https://feraah-api.azurewebsites.net/api/';

//HOMOLOG
// const B2B_API_BASE_URL = 'https://feraah-api-hom.azurewebsites.net/api/';

//PROD
const B2B_API_BASE_URL = 'https://api-feraah.azurewebsites.net/api/';

const urlFromEnv = getApiBaseUrl();
const baseURL =
  urlFromEnv && urlFromEnv !== '/api' ? urlFromEnv : B2B_API_BASE_URL;

function getTenantId(): string | null {
  if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_TENANT_ID) {
    return import.meta.env.VITE_TENANT_ID as string;
  }
  return 'b2b';
}

export const api = createAppApiClient({
  baseURL,
  authKey: 'e-learning-b2b-auth',
  authDataKey: AUTH_DATA_KEY,
  getTenantId,
  redirectPort: '3001',
  basePath: '/b2b',
  getLanguage: () => {
    // A UI usa 'es' no i18n, mas a API/mapping do domínio usa 'es-ES'.
    const lng = i18n.language;
    if (!lng) return 'en-US';
    if (lng === 'es') return 'es-ES';
    return lng;
  },
});
